//
import request from "root/js/request";

const getPostingCancellationDiagramTopTenOzon = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  group_by,
  reverse,
}) => {
  const response = await request({
    url: "/ozon_analytics/posting_cancellation/diagram/top_ten/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      group_by,
      reverse,
    },
  });
  return response.data;
};

export { getPostingCancellationDiagramTopTenOzon };
